import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ResourceService } from 'src/app/services/resource/resource.service';
import { OrderService } from 'src/app/services/order/order.service';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { Email } from 'aws-sdk/clients/codecommit';

@Component({
  selector: 'app-addpickup',
  templateUrl: './addpickup.component.html',
  styleUrls: ['./addpickup.component.scss']
})
export class AddpickupComponent implements OnInit {

  addPickUpForm: FormGroup;
  submitText: string;
  disableAdd: boolean = false;

  constructor(
    private dialogR: MatDialogRef<AddpickupComponent>,
    private formBuilder: FormBuilder,
    private resourceService: ResourceService,
    private orderService: OrderService,
    private notifierService: NotifierService,
    private router: Router
  ) {
    this.submitText = "ADD";
    this.addPickUpForm = this.formBuilder.group({
      'orderType': this.formBuilder.control(null, Validators.required),
      'plannedDate': this.formBuilder.control('', Validators.required),
      'plannedTime': this.formBuilder.control('', Validators.required),
      'receiverName': this.formBuilder.control('', Validators.required),
      'receiverAddress': this.formBuilder.control('', Validators.required),
      'landmark': this.formBuilder.control(''),
      'receiverPhoneNumber': this.formBuilder.control('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{6,11}$")]),
      'receiverPhoneNumber2': this.formBuilder.control('', [Validators.pattern("^((\\+91-?)|0)?[0-9]{6,11}$")]),
      'receiverEmailId': this.formBuilder.control('', [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]),
      'remarks': this.formBuilder.control(null),
      'testType': this.formBuilder.control(null),
      'totalPatients': this.formBuilder.control(null, [Validators.pattern("^[0-9]+$")]),
      'homeVisitCharges': this.formBuilder.control(null, [Validators.pattern("^[0-9]+$")]),
    });

  }

  ngOnInit() {

  }

  closeDialog() {
    this.dialogR.close(false);
  }

  addPickUp() {
    this.submitText = "ADDING"
    console.log("form", this.addPickUpForm.value);
    this.disableAdd = true;
    this.orderService.addOrderPH(this.addPickUpForm.value).subscribe(result => {
      this.disableAdd = false;
      this.notifierService.notify('success', "Pick Up Added Successfully.");
      this.dialogR.close(true);
    }, error => {
      this.disableAdd = false;
      this.notifierService.notify('error', "Error Adding Pick Up, Please Try Again.")
    });
  }

  resetForm() {
    if (this.addPickUpForm) {
      this.addPickUpForm.reset();
    }
    this.addPickUpForm.controls.orderType = null
  }
}